import axios from "axios";
import store from "../../store/index";
import showformmodel from "../showformmodel/showformmodel.vue"
import customModal from "../customModal/customModal.vue";

export default {
    name: "SubActivityForms",
    components: {
        customModal,
        showformmodel,
    },
    props: {
        visitNo: {
            type: String,
            default: ""
        },
        subjectId: {
            type: Number,
            default: ""
        },
        activityId: {
            type: Number,
            default: ""
        },
        activityOrder: {
            type: Number,
            default: ""
        },
        fromPage: {
            type: String,
            default: "Study Profile"
        }
       
    },
    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            studyId: "",
            token: "",
            head: {},
            formlist: [],
            formsCount: 0,
            showViewFormModal: false,
            selectedFormId: "",
            selectedFormStatus: "",
            showLoader: false,
        };
    },
    async mounted() {
        this.studyId = store.getters.getStudyIs;
        this.token = store.getters.getIdToken;
        this.head = {
            headers: {
                Authorization: "Bearer " + this.token,
                "Content-Type": "application/json",
            },
        };
        this.showLoader = true;
        await this.listvisitForms();  
    },
    methods: {  
        async closeFormModal() {
            this.$emit("closeModal");
        }, 
        async listvisitForms( ) {
            await axios.get(
                `${this.baseurl}/management/patientschedule/getfromsbyvisit?studyId=${this.studyId}&patientID=${this.subjectId}&visitNo=${this.visitNo}&activityId=${this.activityId}&activityOrder=${this.activityOrder}`,
                this.head
                )
                .then((res) => {
                console.log("Visit form list is...", res.data.data);
                console.log("Visit form list is...", res.data.totalCount);
                this.formlist = res.data.data;
                this.formsCount = res.data.totalCount;
                })
                .catch((err) => console.log(" error in getting visit forms...", err));
            this.showLoader = false;
        },
        viewForm(formId,formStatus){
            this.selectedFormId=formId;
            this.selectedFormStatus=formStatus;
            this.showViewFormModal = true;
        },
        closeViewFormModal(){
            this.showViewFormModal = false;
        }
    },
   
};